export default __webpack_public_path__ + "static/da-flag-a3f4cdb9cca8b00ecddabf25dcb21569.svg";